import { Address, Ed25519Signature, } from "@dcspark/cardano-multiplatform-lib-nodejs";
import { BigNum, COSEKey, COSESign1, Int, Label, } from "@emurgo/cardano-message-signing-nodejs";
import { Buffer } from "buffer";
import { formatPayload } from "../utils/helpers";
export const signDataWithConnectedWallet = async ({ payload, signingAddress, connectedWallet, }) => {
    const response = await connectedWallet.signData(Buffer.from(Address.from_bech32(signingAddress).to_bytes()).toString("hex"), Buffer.from(typeof payload === "string" ? payload : formatPayload(payload), "utf-8").toString("hex"));
    let key;
    let signature;
    // @ts-ignore eternl wallet returns as { signedData }
    if (response?.signedData) {
        key = response.signedData
            .key;
        signature = response
            .signedData.signature;
    }
    else {
        key = response.key;
        signature = response.signature;
    }
    const coseSign1 = COSESign1.from_bytes(Buffer.from(signature, "hex"));
    const keySign = COSEKey.from_bytes(Buffer.from(key, "hex"));
    const labelInt = Int.new_negative(BigNum.from_str("2"));
    return {
        payload: Buffer.from(coseSign1.signed_data().to_bytes()).toString("hex"),
        signature: Ed25519Signature.from_bytes(coseSign1.signature()).to_hex(),
        key: Buffer.from(keySign.header(Label.new_int(labelInt)).as_bytes()).toString("hex"),
        rawData: { cborKey: key, cborSignature: signature },
    };
};
//# sourceMappingURL=signData.js.map